import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-white px-12 lg:px-20 py-20 sm:py-24 lg:py-28 mt-20 sm:mt-24">
      {/* Thin divider line at top */}
      <div className="w-full h-px bg-black/10 mb-16 sm:mb-20 max-w-[1400px] mx-auto"></div>
      
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-3 gap-20 mb-32">
          
          {/* Brand */}
          <div className="space-y-8">
            <div className="flex items-center gap-4">
              <span className="text-base font-light tracking-[0.25em] text-black">
                LAURA GONZALEZ
              </span>
              <span className="text-base font-extralight text-black">|</span>
              <span className="text-[9px] tracking-[0.35em] text-black/60 uppercase font-light">
                HAIR & MAKEUP ARTIST
              </span>
            </div>
            <p className="text-xs font-light text-black/60 leading-loose">
              Professional hair and makeup artistry for every occasion. Crafting radiant, 
              effortless looks that celebrate your unique beauty with a modern edge.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h3 className="text-[10px] tracking-[2px] uppercase font-light text-black">Navigate</h3>
            <nav className="flex flex-col gap-5">
              <Link to="/about" className="text-xs text-black/60 hover:text-black transition-opacity font-light border-b border-transparent hover:border-black/20 inline-block w-fit">
                About
              </Link>
              <Link to="/services" className="text-xs text-black/60 hover:text-black transition-opacity font-light border-b border-transparent hover:border-black/20 inline-block w-fit">
                Services
              </Link>
              <Link to="/portfolio" className="text-xs text-black/60 hover:text-black transition-opacity font-light border-b border-transparent hover:border-black/20 inline-block w-fit">
                Portfolio
              </Link>
              <Link to="/contact" className="text-xs text-black/60 hover:text-black transition-opacity font-light border-b border-transparent hover:border-black/20 inline-block w-fit">
                Contact
              </Link>
            </nav>
          </div>

          {/* Connect */}
          <div className="space-y-6">
            <h3 className="text-[10px] tracking-[2px] uppercase font-light text-black">Connect</h3>
            <div className="flex flex-col gap-5">
              <a href={`mailto:${mockData.contact.email}`} className="flex items-center gap-3 text-xs text-black/60 hover:text-black transition-opacity font-light">
                <Mail size={14} strokeWidth={1} />
                {mockData.contact.email}
              </a>
              <a href="https://www.instagram.com/laugonzalez.mua?igsh=YmJ3eW1pcnZtd3V5&utm_source=qr" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-xs text-black/60 hover:text-black transition-opacity font-light">
                <Instagram size={14} strokeWidth={1} />
                {mockData.contact.instagram}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar with thin divider - smaller copyright */}
        <div className="pt-12 sm:pt-14 border-t border-black/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-[8px] tracking-[2px] uppercase text-black/30 font-light">
              © 2025 Laura Gonzalez Artistry. All rights reserved.
            </p>
            <p className="text-[8px] tracking-[2px] uppercase text-black/30 font-light">
              {mockData.brand.location}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
